/**
 *@author       罗朝军
 *@date         2021/10/13 14:50
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
import { qryBidEvaProcessStatusApi } from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  data() {
    return {};
  },
  created() {
    this.qryBidEvaProcessStatus();
  },
  mounted() {},
  methods: {
    qryBidEvaProcessStatus() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep:
          this.$router.history.current.name === "supplierComplianceInspection"
            ? "0804"
            : this.$router.history.current.query.menuKey
      }).then(res => {
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
      });
    }
  }
};
